import styled from 'styled-components';
import { lighten } from 'polished';

import { getDimension } from 'styled/helpers/getDimension';

import type { Color } from 'styled/types';

export const Slider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;

  &:before {
    content: '';

    position: absolute;
    left: ${getDimension('size1')};
    bottom: ${getDimension('size1')};

    width: ${getDimension('size4')};
    height: ${getDimension('size4')};
    border-radius: 100%;

    background-color: ${props => props.theme.colors.white};

    transition: transform 0.4s;
  }
`;

export const Input = styled.input`
  &:checked + ${Slider}:before {
    transform: translate(${getDimension('size6')});
  }
`;

export const SwitchContainer = styled.label<{ toggle: boolean; color: Color; disabled?: boolean }>`
  display: inline-block;
  position: relative;

  width: ${getDimension('size10')};
  height: ${getDimension('size6')};
  border-radius: ${getDimension('size3')};

  background-color: ${({ toggle, color, theme, disabled }) =>
    toggle && !disabled ? theme.colors[color] : lighten(0.25, theme.colors.grey)};

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: background-color 0.4s;

  /* Hides the default input checkbox */
  & ${Input} {
    display: none;
  }
`;
